<div class="edit-master-credential-main">
  <!-- Header Section -->
  <div class="header-section">
    <img
      src="/assets/svg/ico-chevron-back-outline.svg"
      class="back-navigation"
      (click)="goBack()"
      alt="Back"
    />
    <div class="header-center">
      <p class="site-name">
        <app-with-tooltip [showHelpCursor]="true">
          {{ selectedSite?.siteName || sharedData?.selectedSite?.siteName }}
        </app-with-tooltip>
      </p>
      <p class="bold-heading">
        {{ "MASTER_CREDENTIAL" | translate }}
      </p>
    </div>
    <div class="spacer"></div>
  </div>

  <!-- Content Section -->
  <div class="content-section">
    <h1 class="heading1">{{ "UPDATE_DESCRIPTION" | translate }}</h1>
    <p class="sub-heading">
      {{ "ENTER_DESCRIPTION_FOR_MASTER_CREDENTIAL" | translate }}
    </p>

    <!-- Form Section -->
    <form
      class="form-section"
      [formGroup]="editDescriptionForm"
      (ngSubmit)="onUpdateDescription()"
    >
      <div class="form-container">
        <mat-form-field appearance="fill" class="description-field">
          <mat-label>{{ "DESCRIPTION" | translate }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            [placeholder]="'DESCRIPTION' | translate"
            formControlName="description"
          ></textarea>
        </mat-form-field>
        <div
          class="field-error"
          *ngIf="
            editDescriptionForm?.controls?.description?.errors?.whitespace &&
            editDescriptionForm?.controls?.description?.touched
          "
        >
          {{ "EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED" | translate }}
        </div>
        <div
          class="field-error"
          *ngIf="
            editDescriptionForm?.controls?.description?.errors?.maxlength &&
            editDescriptionForm?.controls?.description?.touched
          "
        >
          {{
            commonService.stringInterPolation(
              "MAXIMUM_OF_CHARACTERS" | translate,
              "64"
            )
          }}
        </div>
        <div
          class="field-error"
          *ngIf="
            editDescriptionForm?.controls?.description?.errors?.required &&
            editDescriptionForm?.controls?.description?.touched
          "
        >
          {{ "DESCRIPTION_IS_REQUIRED" | translate }}
        </div>
      </div>

      <div class="button-section">
        <button
          class="update-btn"
          type="submit"
          [disabled]="!editDescriptionForm.valid || !isDescriptionChanged()"
        >
          {{ "UPDATE" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
